import * as React from 'react'
import * as styles from './PlayerHover.module.scss'
import * as cn from 'classnames'
import WatchlistActions from '../../../utils/WatchlistActions'
import fireDraperTrackingEvent from '../../../utils/draper'
import * as csm from '../../../utils/csm'
import { Button, PurchaseButton, Translucent } from '@amzn/dvui/dist/Button'
import { Spacer, spacerAlignItems, spacerSpacing } from '@amzn/dvui/dist/Spacer'

import PrerollPlayer from '../../preroll/PrerollPlayer';
import { StorefrontItem } from 'DVWebNodeUtils';
import { SquarePlayButton } from '../../../utils/nody1compatibilityPorts/Button';

interface PlayerHoverProps {
  setImageVisibility: Function
  item: StorefrontItem
  prerollPlayerComponent: PrerollPlayer
  formFactor: string
}

interface PlayerHoverState {
  hasError: boolean
  playerVisible: boolean
  toggle: string
}

export default class PlayerHover extends React.PureComponent<PlayerHoverProps, PlayerHoverState> {
  playerHoverContainer: HTMLDivElement

  constructor(props: PlayerHoverProps) {
    super(props)
    this.state = {
      toggle: styles.hide,
      hasError: false,
      playerVisible: false
    }
    this.toggleOverlay = this.toggleOverlay.bind(this)
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    this.setState({ hasError: true })
    csm.logError(error, '[DVWeb::Storefront::PlayerHover] Error while ' +
      `trying to render dvweb Storefront PlayerHover ${info}`)
  }

  playerVisible(visible: boolean) {
    this.setState({ playerVisible: visible })
    if (this.props.setImageVisibility) {
      this.props.setImageVisibility(!visible)
    }
  }

  toggleOverlay(visible: boolean) {
    const toggleState = visible ? styles.show : styles.hide
    this.setState({ toggle: toggleState })
  }

  render() {
    if (this.state.hasError || !this.props.item) {
      return null
    }

    const textMap = this.props.item.prerolls && this.props.item.prerolls.textMap
    const signUpUrl = this.props.item.entitlements &&
      this.props.item.entitlements.length > 0 &&
      this.props.item.entitlements.indexOf('prime') > -1 &&
      this.props.item.prerolls && this.props.item.prerolls.signUpURL
    const progress = 0
    const deeplinkingData = this.props.item.playbackAction ? {
      fallbackUrl: this.props.item.playbackAction.appFallbackUrl,
      titleId: this.props.item.playbackAction.titleID,
      resumeTime: this.props.item.playbackAction.resumeTime,
      signInUrl: this.props.item.playbackAction.signInUrl,
      sessionId: this.props.item.playbackAction.sessionID,
      pageTitleId: this.props.item.titleID,
      ref: this.props.item.playbackAction.refMarker,
      videoType: this.props.item.playbackAction.videoMaterialType
    } : {}
    return (
      <div className={cn(this.state.toggle, styles.playerOverlay, 'tst-video-overlay')} ref={(elem) => {
        this.playerHoverContainer = elem
      }}>
        <div className={styles.gradientWrapper}>
          <div className={cn(styles.leftGradient, 'tst-video-overlay-info')}>
            <h1 className={cn('tst-video-overlay-title', {[styles.tabletView]: this.props.formFactor === 'Tablet'})}>
              {this.props.item.title}
            </h1>
            <Spacer space={spacerSpacing.s}>
              <span className={cn(styles.clampText, {[styles.tabletView]: this.props.formFactor === 'Tablet'})}>
                {this.props.item.synopsis}
              </span>
            </Spacer>
            <Spacer className={cn(styles.buttonWrapper, 'tst-video-overlay-buttons')} space={spacerSpacing.xs}
              alignItems={spacerAlignItems.top}>
              {
                (this.props.item.playbackAction && this.props.item.playbackAction.signInUrl)
                  ? <PurchaseButton href={this.props.item.playbackAction.signInUrl}>
                    <span className={styles.noIconButton}>
                      {textMap.watchWithPrimeText}
                    </span>
                  </PurchaseButton>
                  : this.props.item.playbackAction
                    ? <SquarePlayButton
                      onClick={() => {
                        fireDraperTrackingEvent(this.props.item.prerolls, 'acceptInvitation')
                        if (this.props.prerollPlayerComponent &&
                          this.props.prerollPlayerComponent.stopHandler) {
                          this.props.prerollPlayerComponent.stopHandler()
                        }
                      }}
                      href={this.props.item.playbackAction.fallbackUrl}
                      deepLinkingData={deeplinkingData} progress={progress}
                    >
                      <span className={cn(styles.extraLineHeight, styles.buttonWithIconText)}>
                        {textMap.watchNowText}
                      </span>
                    </SquarePlayButton>
                    : signUpUrl
                      ? <PurchaseButton href={signUpUrl}>
                        <span className={styles.noIconButton}>
                          {textMap.watchWithPrimeText}
                        </span>
                      </PurchaseButton> : null
              }
              <span className={styles.iconButtonWrapper}>
                  <WatchlistActions
                    buttonTextClassName={styles.buttonWithIconText}
                    addCallback={() => fireDraperTrackingEvent(this.props.item.prerolls, 'addToWatchlist')}
                    watchlistAction={this.props.item.watchlistAction}
                    string={textMap.watchlistText} />
              </span>
              <Button href={this.props.item.link.url} use={Translucent}>
                <span className={styles.noIconButton}>{textMap.detailsText}</span>
              </Button>
            </Spacer>
          </div>
          {this.props.children}
        </div>
      </div>
    )
  }
}
